import { render, staticRenderFns } from "./AirbnbEmbed.vue?vue&type=template&id=2f194579&scoped=true"
import script from "./AirbnbEmbed.vue?vue&type=script&lang=js"
export * from "./AirbnbEmbed.vue?vue&type=script&lang=js"
import style0 from "./AirbnbEmbed.vue?vue&type=style&index=0&id=2f194579&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_webpack@5.94.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f194579",
  null
  
)

export default component.exports